import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { formatToCurrency } from "@utils/formatting";

interface ActivityCardAmountProps {
  amount: number;
  className?: string;
}

export const ActivityCardAmount = ({ amount, className }: ActivityCardAmountProps) => {
  const isCredit = amount > 0;
  const sign = amount !== 0 ? (isCredit ? "+" : "-") : "";

  return (
    <span className={cn("text-lg font-bold", isCredit && "text-success", className)}>
      {sign}
      {formatToCurrency(Math.abs(amount))}
    </span>
  );
};
